import ReactGA from "react-ga";
import ga4 from "react-ga4";
import _ from "lodash";

let trackers;
let trackersNames;
let useGA4Tag;

export const initGA = (
  trackingInternal,
  trackingClient = "",
  useGA4 = false
) => {
  useGA4Tag = useGA4;
  trackers = trackingClient
    ? [
        {
          trackingId: trackingClient,
          gaOptions: {
            name: "trackingClient"
          }
        },
        {
          trackingId: trackingInternal,
          gaOptions: {
            name: "trackingInternal"
          }
        }
      ]
    : [
        {
          trackingId: trackingInternal,
          gaOptions: {
            name: "trackingInternal"
          }
        }
      ];
  trackersNames = trackers.map((t) => t.gaOptions.name);
  if (useGA4Tag) {
    ga4.initialize(trackers);
  } else {
    ReactGA.initialize(trackers);
  }
};

export const PageView = () => {
  if (!_.isUndefined(trackersNames) && trackersNames.length > 0) {
    const { pathname } = window.location;
    if (useGA4Tag) {
      ga4.send({ hitType: "pageview", page: pathname });
    } else {
      ReactGA.pageview(pathname, trackersNames);
    }
  }
};

export const Event = (
  category,
  action,
  label,
  nonInteraction = false,
  dimensions = {},
  metrics = {}
) => {
  const options = {
    category,
    action,
    label,
    nonInteraction,
    ...dimensions,
    ...metrics
  };

  if (useGA4Tag) {
    ga4.event(options);
  } else {
    ReactGA.event(options, trackersNames);
  }
};
